
import * as React from 'react';
import { injectInitialProps } from '../../../utilities/components/Props';
import { IUploaderProps, IFileSelectorProps } from '../../uploader/Uploader';
import { ItemUploadAction, IItemUploadActionProps } from './UploadAction';
import { withOnlyCurrentItem, IDecorateWithOnlyCurrentItemProps } from '../../decorators/selectors';
import { getFileDropEntries } from '../../../utilities/dragAndDrop/files';
import { IDecoratedProps } from '../../../utilities/components/Decorators';

export type IItemUploadEntriesActionProps = IDecoratedProps<IItemUploadActionProps, Pick<IUploaderProps, 'fileSelector'>, {}>;

class DropFileSelector extends React.PureComponent<IFileSelectorProps> {
  public async componentDidMount(): Promise<void> {
    const {
      onContinue,
      onExecuteProps
    } = this.props;

    if (onExecuteProps && onExecuteProps.event) {
      const entries = getFileDropEntries(onExecuteProps.event as React.DragEvent<HTMLElement>);

      onContinue(entries);
    } else {
      this.props.onCancel();
    }
  }

  public render(): JSX.Element | null {
    return null;
  }
}

/**
 * Upload variant which extracts file system entries from a drag event.
 */
export const ItemUploadEntriesAction: React.ComponentType<IItemUploadEntriesActionProps> =
  injectInitialProps((): Pick<IUploaderProps, 'fileSelector'> => {
    return {
      fileSelector: DropFileSelector
    };
  })(ItemUploadAction);

export type IUploadEntriesActionProps = IDecorateWithOnlyCurrentItemProps<IItemUploadEntriesActionProps>;

export const UploadEntriesAction: React.ComponentType<IUploadEntriesActionProps> = withOnlyCurrentItem()(ItemUploadEntriesAction);
